import { createAction, props } from '@ngrx/store';

export interface INotification {
  title: string;
  message?: string;
}

export interface ISendedNotification extends INotification {
  notificationType: string;
}

export const sended = createAction(
  '[Notifications] Sended',
  props<ISendedNotification>(),
);

export const error = createAction(
  '[Notifications] Error',
  props<INotification>(),
);

export const waiting = createAction(
  '[Notifications] Waiting',
  props<INotification>(),
);

export const success = createAction(
  '[Notifications] Success',
  props<INotification>(),
);
